import { createSlice } from "@reduxjs/toolkit";
import ShopifyClient from "shopify/client";
import { allMeals } from "utils/constants";

const initialState = {
	isClient: false,
	hasOfferBar: false,
	isOneTimeSession: false,
	isDedicatedOneTimeFlow: false,
	stickyATCShown: false,
	shopifyClient: new ShopifyClient(),
	view: allMeals,
	variantWeights: {},
	subscriptionShippingMethods: null,
};

const globalSlice = createSlice({
	name: "global",
	initialState,
	reducers: {
		setGlobalData: (state, action) => {
			if (state.isClient) return;
			Object.assign(state, action.payload);
			state.isClient = true;
		},
		setHasOfferBar: (state, action) => {
			state.hasOfferBar = action.payload;
		},
		setOneTimeSession: (state, action) => {
			state.isOneTimeSession = action.payload;
		},
		setDedicatedOneTimeFlow: (state, action) => {
			state.isDedicatedOneTimeFlow = action.payload;
		},
		setStickyATCVisible: (state, action) => {
			state.stickyATCShown = action.payload;
		},
		setView: (state, action) => {
			state.view = action.payload;
		},
	},
});

export const {
	setGlobalData,
	setHasOfferBar,
	setOneTimeSession,
	setDedicatedOneTimeFlow,
	setStickyATCVisible,
	setView,
} = globalSlice.actions;

export default globalSlice.reducer;
